module.exports = __webpack_public_path__ + "images/category_lp/camera/Leica-M35mm-F2-ASPH.(6bit)_ac83e1aebe5f3858161f76b404c85465.png";